import {
  TODAY, YESTERDAY, SEVEN_DAYS, FOURTEEN_DAYS, WEEK_TO_DATE, MONTH_TO_DATE, THIRTY_DAYS, NINETY_DAYS
} from 'constants/report';


import moment from 'moment';
import _ from 'lodash';
import BuildUrl from 'build-url';
import numeral from 'numeral';

export const getReportDatesForOption = (key) => {
  switch(key){
    case TODAY:
      return {
        startDate: moment(),
        endDate: moment()
      }

    case YESTERDAY:
      return {
        startDate: moment().subtract(1, 'days'),
        endDate: moment().subtract(1, 'days')
      }

    case SEVEN_DAYS:
      return {
        startDate: moment().subtract(7, 'days'),
        endDate: moment()
      }  
    
    case FOURTEEN_DAYS:
      return {
        startDate: moment().subtract(14, 'days'),
        endDate: moment()
      }
      
    case WEEK_TO_DATE:
      return {
        startDate: moment().startOf('week'),
        endDate: moment()
      }
    
    case MONTH_TO_DATE:
      return {
        startDate: moment().startOf('month'),
        endDate: moment()
      }
  
    case THIRTY_DAYS:
      return {
        startDate: moment().subtract(30, 'days'),
        endDate: moment()
      }  

    case NINETY_DAYS:
      return {
        startDate: moment().subtract(90, 'days'),
        endDate: moment()
      }    

    default:
      return {
        startDate: moment(),
        endDate: moment()
      }  
  }
}

export const generateReportUrl = (url, reportDate, paramsString) => {
  const queryParams = generateQueryParams(reportDate, null);

  const params = new URLSearchParams(paramsString);

  const query = {
    ...params,
    ...queryParams
  };

  const updated = BuildUrl(url, {
    queryParams: query
  });

  return updated;
}

export const generateQueryParams = (value) => {  
  const type = _.get(value, 'type');
  const startDate = _.get(value, 'startDate');
  const endDate = _.get(value, 'endDate');

  return {
    type: type,
    startDate: startDate.format('DD/MM/YYYY'),
    endDate: endDate.format('DD/MM/YYYY')
  }
}

export const parseQueryParams = (search) => {  
  const params = new URLSearchParams(search); 

  const type = params.get('type');
  const startDate = params.get('startDate'); 
  const endDate = params.get('endDate');

  if(!type){
    return {
      type: FOURTEEN_DAYS,
      ...getReportDatesForOption(FOURTEEN_DAYS)
    }
  }

  return {
    type: type,
    startDate: moment(startDate, 'DD/MM/YYYY'),
    endDate: moment(endDate, 'DD/MM/YYYY')
  }
}

export const convertDatesToTimezone = (value) => {
  const startDate = _.get(value, 'startDate');
  let endDate = _.get(value, 'endDate');

  endDate = moment(endDate).add(1, "days")

  if(!startDate || !endDate) {
    return {}
  }

  const startDateValue = startDate.startOf('day');
  const endDateValue = endDate.startOf('day');
  
  return {
    startDate: startDateValue.format('YYYY-MM-DDTHH:mm:ss+00:00'),
    endDate: endDateValue.format('YYYY-MM-DDTHH:mm:ss+00:00')
  }
}

export const formatTimespent = (seconds = 0) => {
  var timeSpent = seconds;
  var unit = 's';
  
  if(timeSpent >= 60){
    timeSpent = timeSpent / 60;
    unit = 'm';
  }

  return `~${numeral(timeSpent).format('0')}${unit}`;
}

export const formatName = (entity) => {
  return `${_.get(entity, 'firstName') || ''} ${_.get(entity, 'lastName') || ''} `;
}